'use client';

import { BuyBoxHeading } from '@eliadmin/core/src/components/dlz/product-detail/buy-box/buy-box-heading';
import {
  BuyBoxDescription,
  BuyBoxHighlights,
} from '@eliadmin/core/src/components/dlz/product-detail/buy-box/buy-box-summary';
import { DeliveryBox } from '@eliadmin/core/src/components/dlz/product-detail/buy-box/delivery-box';
import { PurchaseSection } from '@eliadmin/core/src/components/dlz/product-detail/buy-box/purchase-section';
import { ProductSecondaryActions } from '@eliadmin/core/src/components/dlz/product-detail/extras/product-secondary-actions';
import type { BuyBoxContent } from '@eliadmin/core/src/components/dlz/product-detail/types';

const TITLE_ID = 'product-title';

/** Figma „Buy box“ (60145:11486): heading, summary, purchase section and delivery info, 24 px apart. */
export function ProductBuyBox({ content }: { content: BuyBoxContent }) {
  return (
    <section
      data-section="product-buy-box"
      aria-labelledby={TITLE_ID}
      className="flex min-w-0 flex-col gap-6"
    >
      <BuyBoxHeading titleId={TITLE_ID} />
      <BuyBoxDescription />
      <BuyBoxHighlights items={content.highlights} />
      <hr className="h-px border-0 bg-[#E2E4E7]" />
      <PurchaseSection dispatchNote={content.dispatchNote} />
      <DeliveryBox items={content.delivery} />
      <ProductSecondaryActions />
    </section>
  );
}
